export const cleanLanguageCode = (languageCode) => {
  if (languageCode.includes('-')) {
    return languageCode.split('-')[0];
  }
  return languageCode;
};
